import { Pipe, PipeTransform } from '@angular/core';
import { SubmissionState } from '@ca/core/models';

@Pipe({ name: 'workflowSubmissionStateTranslationKey' })
export class WorkflowSubmissionStateTranslationKeyPipe implements PipeTransform {
    transform(state: SubmissionState): string {
        switch (state) {
            case SubmissionState.approved:
                return 'WORKFLOWS.SUBMISSION_STATE.APPROVED';
            case SubmissionState.inReview:
                return 'WORKFLOWS.SUBMISSION_STATE.IN_REVIEW';
            case SubmissionState.rejected:
                return 'WORKFLOWS.SUBMISSION_STATE.REJECTED';
            case SubmissionState.unpublished:
                return 'WORKFLOWS.SUBMISSION_STATE.UNPUBLISHED';
            default:
                return 'WORKFLOWS.SUBMISSION_STATE.UNKNOWN';
        }
    }
}
